export interface IHouseCreditTransaction {
  houseCreditTransactionId: string;
  houseFlatId: string;
  neighborhoodId: string;
  amount: number;
  type: 'deposit' | 'applied' | 'refund';
  paymentId?: string;
  movementId?: string;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

export class HouseCreditTransaction implements IHouseCreditTransaction {
  houseCreditTransactionId: string;
  houseFlatId: string;
  neighborhoodId: string;
  amount: number;
  type: 'deposit' | 'applied' | 'refund';
  paymentId?: string;
  movementId?: string;
  notes: string;
  createdAt: string;
  updatedAt: string;

  constructor(json: IHouseCreditTransaction) {
    this.houseCreditTransactionId = json.houseCreditTransactionId;
    this.houseFlatId = json.houseFlatId;
    this.neighborhoodId = json.neighborhoodId;
    this.amount = json.amount;
    this.type = json.type;
    this.paymentId = json.paymentId;
    this.movementId = json.movementId;
    this.notes = json.notes;
    this.createdAt = json.createdAt;
    this.updatedAt = json.updatedAt;
  }
}
